import moment from 'moment'
import { saveAs } from 'file-saver'

import { FAMILY_ALBUM_CUSTOMERS_EXPORT_EXCEL_FULFILLED } from 'Global/Stores/familyAlbum'
import { RUGS_EXPORT_EXCEL_FULFILLED } from 'Global/Stores/rugs'
import { ISO_DATE_FORMAT, TITLE } from 'Global/constants'

const saveAsMiddleware = store => next => action => {
  if (action.type !== RUGS_EXPORT_EXCEL_FULFILLED && action.type !== FAMILY_ALBUM_CUSTOMERS_EXPORT_EXCEL_FULFILLED) {
    return next(action)
  }

  const blob = new Blob([action.payload.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  saveAs(blob, `${moment().format(ISO_DATE_FORMAT)} - ${TITLE} Export`)

  return next(action)
}

export default saveAsMiddleware
